if (!customElements.get('promo-timer')) {
  class PromoTimer extends HTMLElement {
    connectedCallback() {
      requestAnimationFrame(() => {
        this.init();
      });
    }

    init() {
      const year = Number(this.dataset.year);
      const month = Number(this.dataset.month) - 1;
      const day = Number(this.dataset.day);
      const hour = Number(this.dataset.hour);
      const minute = Number(this.dataset.minute);
      

      this.targetDate = new Date(
        year,
        month,
        day,
        hour,
        minute,
        0
      );

      this.daysEl = this.querySelector('.days');
      this.hoursEl = this.querySelector('.hours');
      this.minutesEl = this.querySelector('.minutes');
      this.secondsEl = this.querySelector('.seconds');

      if (
        !this.daysEl ||
        !this.hoursEl ||
        !this.minutesEl ||
        !this.secondsEl
      ) {
        return;
      }

      this.updateTimer();

      this.interval = setInterval(() => {
        this.updateTimer();
      }, 1000);
    }

    disconnectedCallback() {
      if (this.interval) {
        clearInterval(this.interval);
      }
    }

    updateTimer() {
      const now = Date.now();
      const distance = this.targetDate.getTime() - now;

      if (distance <= 0) {
        this.updateValues(0, 0, 0, 0);
        clearInterval(this.interval);
        return;
      }

      const days = Math.floor(
        distance / 86400000
      );

      const hours = Math.floor(
        (distance % 86400000) / 3600000
      );

      const minutes = Math.floor(
        (distance % 3600000) / 60000
      );

      const seconds = Math.floor(
        (distance % 60000) / 1000
      );

      this.updateValues(
        days,
        hours,
        minutes,
        seconds
      );
    }

    updateValues(days, hours, minutes, seconds) {
      this.daysEl.textContent = String(days).padStart(2, '0');
      this.hoursEl.textContent = String(hours).padStart(2, '0');
      this.minutesEl.textContent = String(minutes).padStart(2, '0');
      this.secondsEl.textContent = String(seconds).padStart(2, '0');
    }
  }

  customElements.define('promo-timer', PromoTimer);
}